import { inject } from 'vue'
import { PostHog } from 'posthog-js'

export function usePostHog() {
  const posthog = inject<PostHog>('posthog')
  if (!posthog) {
    throw new Error('usePostHog() was called without providing the posthog plugin')
  }
  return posthog
}
